import React from 'react';
import styled from "@emotion/styled"
import SectionHeadline from './SectionHeadline';
import { Link } from 'gatsby'
import parse from 'html-react-parser';
import breakpoints from '../../styles/breakpoints.js';

const Session =({ title, subtitle, children }) =>
{
  return(
    <SectionWrapper>
      {title &&
        <SectionHeadline title={title} subtitle={subtitle} />
      }
      
      <div>{children}</div>
    </SectionWrapper>
  );

}

export default Session;


const SectionWrapper = styled.section`
  padding:64px 64px 80px;
  max-width:1440px;
  margin:0 auto;
  position:relative;
  z-index:2;
  width:100%;

  h2{
    margin:0;
  }

  @media all and (max-width: ${breakpoints.smMax}){
    padding:64px 32px;

  }
  @media all and (max-width: ${breakpoints.xsMax}){
    padding:48px 16px;

  }
`